import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "../ContactFrom/ContactForm";
import "./contactform.css";

const ContactSection = () => {
  return (
    <section className="contact_section section_space pt-0">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="comment_form comment_form_adjusted mb-0">
              <h3 className="details_info_title">Contact Us</h3>
              <p>
                For inquiries, transfers, or joining our team as a partner,
                contact us at:
              </p>
              <ContactForm />
            </div>
          </div>

          <div className="col-lg-4">
            <div className="contact_info_box enquriy_contact_info_box">
              <ul className="contact_info_list unordered_list_block">
                {/* <li>
                  <Link to="/contact">
                    <span className="icon">
                      <i className="fa-solid fa-phone-volume"></i>
                    </span>
                    <span className="label">+44 7378 230164</span>
                  </Link>
                </li> */}
                <li className="d-flex flex-column text-start">
                  <small className="text-dark opacity-50">Enquiries</small>
                  <Link to="/contact">
                    <div className="d-flex">
                      <span className="icon">
                        <i className="fa-solid fa-phone-volume"></i>
                      </span>

                      <span className="label">+44 7378 499765</span>
                    </div>
                  </Link>
                </li>
                <li>
                  <Link to="/contact">
                    <span className="icon">
                      <i className="fa-solid fa-envelope"></i>
                    </span>
                    <span className="label">info@topcoinuk.com</span>
                  </Link>
                </li>
              </ul>
              <ul className="social_block style_4 unordered_list">
                <li>
                  <Link to="/contact" className="text-white">
                    <i className="fa-brands fa-facebook-f"></i>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white">
                    <i className="fa-brands fa-twitter"></i>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="text-white">
                    <i className="fa-brands fa-linkedin-in"></i>
                  </Link>
                </li>
              </ul>
              <hr />
              <ul className="iconlist_block unordered_list_block">
                {/* <li>
                                    <span className="iconlist_label">
                                        United States Office
                                        <small className="iconlist_info">
                                            Sunshine example park, Floor No 05A, Sector-94,
                                        </small>
                                    </span>
                                </li> */}
                <li>
                  <span className="iconlist_label">
                    United Kingdom Office
                    <small className="iconlist_info">
                      Address: 20 Wenlock Road, London, United Kingdom, N1 7GU
                    </small>
                  </span>
                </li>
              </ul>
              <hr />
              <ul className="iconlist_block unordered_list_block">
                <li>
                  <span className="iconlist_label">
                    Our Office Open Time
                    <small className="iconlist_info d-block">
                      Mon - Sat: 08.00 AM - 05.00 PM
                    </small>
                    <small className="iconlist_info d-block">
                      Sunday: Closed
                    </small>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="gmap_canvas">
          <iframe
            src="https://maps.google.com/maps?q=!1m18!1m12!1m3!1d2482.0534758418603!2d-0.09368370000000001!3d51.530578999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761ca0ab293773%3A0x2fa1c7e51036d3a1!2s20%20Wenlock%20Rd%2C%20London%20N1%207GU%2C%20UK!5e0!3m2!1sen!2sin!4v1750398696053!5m2!1sen!2sin=&output=embed"
            title="Google Map"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
